import { useRef, useState } from "react";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { useForm } from "react-hook-form";
import CommonButtonSpinner from "../../CommonButtonSpinner/CommonButtonSpinner";
import { useDispatch } from "react-redux";
import { memberLoginAction, memberSearchAction } from "../../../Redux/Action/MemberPanelAction";
import { FaSearch } from "react-icons/fa";



function MemberSearchArea(props) {
    // hooks
    const loginBtnRef = useRef();
    const dispatch = useDispatch();
    const {
        register,
        formState: { errors },
        handleSubmit,
    } = useForm();

    //State
    const [serchData, setSerchData] = useState([])

    // form on submit
    const onSubmit = (data) => {
        // making payload
        const payload = {
            data: data,
            loginBtnRef,
            setSerchData
        };


        dispatch(memberSearchAction(payload));
    };
    console.log(serchData)
    return (
        <>
            <Form onSubmit={handleSubmit(onSubmit)}>
                {/* user name */}
                <Form.Group className="mb-3" controlId="formBasicEmail">

                    <Form.Control
                        type="text"
                        placeholder="Enter your phone no."
                        className={errors.member_id ? "is-invalid" : ""}
                        {...register("search_key", { required: true })}
                    />
                    {errors.search_key && (
                        <small className="text-danger">
                            {errors.search_key.type == "required" && "This field is required!"}
                        </small>
                    )}
                    <Button ref={loginBtnRef} variant="primary" type="submit">
                        <FaSearch />

                    </Button>
                </Form.Group>



                {/* login button */}

            </Form>
            {serchData.length != 0 ? <><Row className="mt-5">
                <Col>
                    <Table striped bordered hover >
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>Name</th>
                                <th>Guardian Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            {serchData.map((singleData, index) => (
                                <tr key={index}>
                                    <td>{singleData.id}</td>
                                    <td>{singleData.member_name}</td>
                                    <td>{singleData.guardian_name}</td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>
                </Col>

            </Row></> : ""}
        </>
    );
}

export default MemberSearchArea;